// Vendors
import React from 'react';

import { tablefy } from '../../../components/helpers';

const GasEpat = ({ projectData, openAccordion, handleToggleAccordion }) => {
  const { documentEpatUrl } = window.wlPipAdmin;
  const {
    gas_rep_company_name,
    gas_rep_representative,
    gas_rep_city,
    gas_rep_state
  } = projectData;
  const epatTableFields = {
    so2: 'SO2 (lb)',
    nox: 'NOx (lb)',
    co2: 'CO2 (1000 lb)',
    ch4: 'CH4 (lb)',
    n2o: 'N2O (lb)',
    co2e: 'CO2e (1000 lb)'
  };

  return (
    <div className="grid__col-xs-12 u--margin-bottom-20">
      <button
        className={`btn btn--white btn--block btn--lg btn--pip-accordion btn--has-arrow module-hover-root ${
          openAccordion['gas-epat'] === true ? 'btn--pip-accordion--on' : ''
        }`}
        type="button"
        onClick={() => handleToggleAccordion('gas-epat')}
      >
        <span className="btn__content u--display-flex u--align-items-center u--justify-content-space-between u--padding-left-20 u--padding-right-20 u--padding-top-5 u--padding-bottom-5 u--height-auto">
          <span className="btn__text">Propane Provider & EPAT</span>
          <span className="btn__arrow"></span>
        </span>
      </button>
      <div
        className={
          openAccordion['gas-epat'] === true
            ? 'u--display-block u--padding-top-20 u--squash-end u--padding-bottom-10'
            : 'u--display-none'
        }
      >
        {tablefy(
          {
            'Provider Company': gas_rep_company_name ? gas_rep_company_name : 0,
            'Provider Rep.': gas_rep_representative
              ? gas_rep_representative
              : 0,
            'Provider City': gas_rep_city ? gas_rep_city : 0,
            'Provider State': gas_rep_state ? gas_rep_state : 0,
            EPAT: documentEpatUrl ? (
              <strong>
                <a href={documentEpatUrl} target="_blank">
                  {documentEpatUrl.split('/').pop()}
                </a>
              </strong>
            ) : (
              '(none uploaded)'
            )
          },
          true
        )}
        <p className="u--margin-top-30 u--margin-bottom-10 u--padding-left-5 u--font-size-md">
          EPAT Annual Source Emissions:
        </p>
        <table className="epat__table">
          <thead>
            <tr>
              <th></th>
              {Object.entries(epatTableFields).map((field, index) => (
                <th key={index}>{field[1]}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from(['baseline', 'alternative']).map((property) => (
              <tr key={property}>
                <td>{property.charAt(0).toUpperCase() + property.slice(1)}</td>
                {Object.entries(epatTableFields).map((field, index) => {
                  const propertyName = `epat_emissions_${property}_${field[0]}`;

                  return (
                    <td key={`td_${index}`}>
                      <input
                        type="number"
                        className="form__input form__input--sm form__input--no-shadow"
                        name={`epat_emissions_${property}_${field[0]}`}
                        defaultValue={projectData[propertyName]}
                      />
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GasEpat;
